import { PROFICIENCY_LIST_COUNT } from '../../../settings.js'
import connector from '../../connector.js'

/**
 * Get material
 * @param {Object} options
 * @param {number} options.id Material ID
 */
export function get ({ id }) {
  return connector.get(`proficiency/materials/${id}`).json()
}

/**
 * Get material list
 * @param {Object} filter Filter options
 * @param {string} filter.search Search term
 * @param {number} filter.offset Offset value
 * @param {number} [filter.limit=100] Number of results
 * @param {import('ky').Options} [options] Request options
 */
export function getList ({ search, offset, limit = PROFICIENCY_LIST_COUNT }, options) {
  const searchParams = { limit, search, offset }
  return connector.get('proficiency/materials', { searchParams, ...options }).json()
}

/**
 * Create new material
 * @param {Object} options
 * @param {Object} options.data Material data
 */
export function create ({ data }) {
  return connector.post('proficiency/materials', data).json()
}

/**
 * Update existing material
 * @param {Object} options
 * @param {number} options.id Material ID
 * @param {Object} options.data Material data
 */
export function update ({ id, data }) {
  return connector.patch(`proficiency/materials/${id}`, data).json()
}

/**
 * Remove material
 * @param {Object} options
 * @param {number} options.id Material ID
 */
export function remove ({ id }) {
  return connector.delete(`proficiency/materials/${id}`).json()
}

export function preflight (id) {
  return connector.get(`proficiency/materials/${id}/delete-preflight`).json()
}
